<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true>
    <app-nav-tab [title]="t('app.common.races')" [itemId]="1">
      <ng-template>
        <app-event-management-race-list [eventItem]="eventItem" [languages]="languages"
                                        [disableRegisterToRace]="disableRegisterToRace"
                                        (registerToRace)="registerToRace()"
                                        (getFileFromServer)="getFileFromServer($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.management.participants')" [itemId]="2">
      <ng-template>
        <app-event-management-participants-list [languages]="languages" [filter]="filter" [searchForm]="searchForm"
                                                [event]="eventItem"
                                                [applicationFormSettingsList]="applicationFromSettingsList"
                                                [raceSettingsList]="settingsList"
                                                [disableRegisterToRace]="disableRegisterToRace"
                                                [competitors]="competitors"
                                                (registerToRace)="registerToRace()"
                                                (getFileFromServer)="getEventParticipanstFileFromServer($event.type, $event.filter)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('organiser.event.management.registrations')" [itemId]="3">
      <ng-template>
        <app-event-management-registrations-list [eventItem]="eventItem" [languages]="languages"
                                                 [raceRegistrations]="raceRegistrations"
                                                 [disableRegisterToRace]="disableRegisterToRace"
                                                 [hasMore]="hasMoreRaceRegistrations"
                                                 [raceRegistrationsPage]="raceRegistrationsPage"
                                                 (registerToRace)="registerToRace()"
                                                 (getFileFromServer)="getFileFromServer($event)"
                                                 (onHasMore)="hasMoreRaceRegistrations=$event"
                                                 (onRaceRegistrations)="raceRegistrations=$event"
                                                 (onRaceRegistrationsPage)="raceRegistrationsPage=$event"/>

      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>
  <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
